/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/student.scss';
import Tab from '../../component/Inc/Tab';
import Paging from '../../component/Inc/Paging';
import PopFirstClassReport from './_PopFirstClassReport';
function FirstClassReport() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '전체', cnt: '45', value: 0},
    {title: '첫수업 보고서', value: 1},
    {title: '첫수업 보고서 미작성', value: 2},
    {title: '모니터링 보고서', value: 3},
    {title: '모니터링 보고서 미작성 ', type: ' red', value: 4},
    {title: '내 보고서  ', type: ' red', value: 5}
  ];
  const [detailTabIdx, setDetailTabIdx] = useState(0);
  const detailTab = [
    {title: '첫 수업 보고서', value: 0},
    {title: '모니터링 보고서', value: 1}
  ];
  const [modalFirstClassReport, setModalFirstClassReport] = useState(false);
  return (
    <main className="com_container p_first_class">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_7 ">첫 수업 & 모니터링 보고서</h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalFirstClassReport(true)} className="com_btn orange s btn_plus">
              첫 수업 보고서 작성
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          {/* 수업정보 */}
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <button className="com_btn s btn_request red">내 보고서(45)</button>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <section className="com_board_search end">
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                </div>
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <div className="board_select">
                <div className="check">
                  <input type="radio" name="rdo_1" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">전체</label>
                  <input type="radio" name="rdo_1" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">국어</label>
                  <input type="radio" name="rdo_1" id="rdo03" className="com_chk circle" />
                  <label htmlFor="rdo03">영어</label>
                  <input type="radio" name="rdo_1" id="rdo04" className="com_chk circle" />
                  <label htmlFor="rdo04">수학 </label>
                  <input type="radio" name="rdo_1" id="rdo05" className="com_chk circle" />
                  <label htmlFor="rdo05">과탐</label>
                  <input type="radio" name="rdo_1" id="rdo06" className="com_chk circle" />
                  <label htmlFor="rdo06">사탐</label>
                  <input type="radio" name="rdo_1" id="rdo07" className="com_chk circle" />
                  <label htmlFor="rdo07">수시</label>
                  <input type="radio" name="rdo_1" id="rdo08" className="com_chk circle" />
                  <label htmlFor="rdo08">논술</label>
                </div>
              </div>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="4%" />
                <col width="5%" />
                <col width="5%" />
                <col width="5%" />
                <col width="5%" />
                <col width="10%" />
                <col width="11%" />
                <col width="11%" />
                <col width="8%" />
                <col width="5%" />
                <col width="10%" />
                <col width="10%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>학생명</th>
                  <th>과목</th>
                  <th>구분</th>
                  <th>학교</th>
                  <th>지역</th>
                  <th>첫 수업일</th>
                  <th>사전통화</th>
                  <th>교사</th>
                  <th>담임</th>
                  <th>첫 수업 보고서</th>
                  <th>모니터링 보고서</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>11</td>
                  <td>
                    <button className="name btn_link">가길동102</button>
                  </td>
                  <td>수학</td>
                  <td>본사</td>
                  <td>서울고</td>
                  <td>경기도 수원시</td>
                  <td className="td_date">2022.08.25 12:30</td>

                  <td className="td_point">
                    <div className="check ">
                      <input type="checkbox" name="chk" id="chk_01" className="com_chk" />
                      <label htmlFor="chk_01" className="com_txt_blue">
                        사전통화 확인
                      </label>
                    </div>
                  </td>
                  <td>
                    <button className="name btn_link">가선생102</button>
                  </td>
                  <td>
                    <button className="name btn_link">가담임102</button>
                  </td>
                  <td className="td_red">
                    <button className="name btn_link">작성하기</button>
                  </td>
                  <td className="td_point">
                    <button className="name btn_link">작성하기</button>
                  </td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{10 - idx}</td>
                      <td>
                        <button className="name btn_link">가길동102</button>
                      </td>
                      <td>수학</td>
                      <td>본사</td>
                      <td>서울고</td>
                      <td>경기도 수원시</td>
                      <td className="td_date">2022.08.25 12:30</td>
                      <td className="td_date">2022.08.25 12:30</td>
                      <td>
                        <button className="name btn_link">가선생102</button>
                      </td>
                      <td>
                        <button className="name btn_link">가담임102</button>
                      </td>
                      <td className="td_point">
                        매우긍정 <br />
                        2025.08.30
                      </td>
                      <td className="td_point">
                        <button className="name btn_link">작성하기</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 담당 학생 */}
          <section className="box">
            <div className="detail_tit dot">보고서 상세</div>
            <Tab data={detailTab} tab={detailTabIdx} setTab={setDetailTabIdx} tabStyle="full" />
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <div className="count">
                <button className="btn_edit" />
                <button className="btn_delete" />
              </div>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="cont">
                    <button className="name btn_link">홍길동103 </button>
                    <span className="desc"> (고3ㆍ경기고등학교ㆍ본사) </span>
                  </span>
                </div>
                <div className="info">
                  <span className="tit">연락처</span>
                  <div className="cont">
                    <p className="txt">010-1234-233</p>
                    <p className="txt">
                      <span>부)010-1234-233</span>
                      <span className="dot" />
                      <span>모)010-1234-233</span>
                    </p>
                  </div>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">첫 수업일시</span>
                  <span className="cont">2023.05.10 12:30</span>
                </div>
                <div className="info">
                  <span className="tit">다음 수업일시</span>
                  <span className="cont">2023.05.10 12:30</span>
                </div>
                <div className="info">
                  <span className="tit">교사</span>
                  <span className="cont">
                    <button className=" btn_link">김교사302</button>
                  </span>
                </div>
                <div className="info">
                  <span className="tit">담임</span>
                  <span className="cont">
                    <button className=" btn_link">김담임302</button>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업 방법</span>
                  <span className="cont">대면</span>
                </div>
                <div className="info">
                  <span className="tit">수업 과목</span>
                  <span className="cont">과탐</span>
                </div>
                <div className="info">
                  <span className="tit">기수 / 타임</span>
                  <span className="cont">2기 / 2T</span>
                </div>
                <div className="info">
                  <span className="tit">이지교재</span>
                  <span className="cont">교재명</span>
                </div>
              </div>
              <div className="com_board_box">
                <div className="board_item">
                  <div className="info">
                    <span className="tit">수업 도착시간</span>
                    <span className="cont">
                      지각 <span className="dot" /> 30분
                    </span>
                  </div>
                  <div className="info">
                    <span className="tit">지각시 통화 여부</span>
                    <span className="cont">통화함</span>
                  </div>
                  <div className="info">
                    <span className="tit">학생반응</span>
                    <span className="cont">매우긍정</span>
                  </div>
                  <div className="info">
                    <span className="tit">수업이해도</span>
                    <span className="cont">보통</span>
                  </div>

                  <div className="info">
                    <span className="tit">등급 수준</span>
                    <span className="cont ">2~3 등급</span>
                  </div>
                  <div className="info">
                    <span className="tit">학부모 반응</span>
                    <span className="cont ">대체로 긍정</span>
                  </div>
                  <div className="info">
                    <span className="tit">수업진행가능성</span>
                    <span className="cont">매우긍정</span>
                  </div>
                  <div className="info">
                    <span className="tit">상담내용</span>
                    <span className="cont">학습계획</span>
                  </div>

                  <hr className="com_divider" />
                  <div className="info">
                    <span className="tit">문제점</span>
                    <span className="cont ">없음</span>
                  </div>
                  <div className="info">
                    <span className="tit">메모</span>
                    <span className="cont">-</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name">김담임102 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">수고하셨습니다.</div>
              </div>
            </div>
            <div className="com_board_box">
              <textarea name="" className="textarea" placeholder="내용 입력" />
            </div>
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange s">등록</button>
            </div>
          </section>
        </section>
      </div>
      <PopFirstClassReport open={modalFirstClassReport} close={() => setModalFirstClassReport(false)} />
    </main>
  );
}

export default FirstClassReport;
